import {
  MemberMileageLogType,
  MileageLogDto,
  PointLogType,
} from "../../../../../../api/member";
import { SeedLogType } from "../../../../../../api/seed";
import { SubPrizeRewardLogType } from "../../../../../../api/sub-prize";
import { formatDateHHMM } from "../../../../../../utils/date";

const formatDateToMMDDSlash = (value: Date): string => {
  const month = (value.getMonth() + 1).toString().padStart(2, "0");
  const day = value.getDate().toString().padStart(2, "0");
  return `${month}/${day}`;
};

// 마일리지
export const subTitleForMileage = (
  type: MemberMileageLogType,
  item: MileageLogDto,
) => {
  switch (type) {
    case MemberMileageLogType.CASH:
      return formatDateToMMDDSlash(new Date(item.expiredAt)) + " 소멸 예정";
    case MemberMileageLogType.BANK:
      return formatDateToMMDDSlash(new Date(item.expiredAt)) + " 소멸 예정";
    case MemberMileageLogType.CARD:
      return formatDateToMMDDSlash(new Date(item.expiredAt)) + " 소멸 예정";
    case MemberMileageLogType.BUY:
      return item.menu;
    case MemberMileageLogType.CASH_CANCEL:
      return formatDateHHMM(item.date) + " 취소";
    case MemberMileageLogType.BANK_CANCEL:
      return formatDateHHMM(item.date) + " 취소";
    case MemberMileageLogType.CARD_CANCEL:
      return formatDateHHMM(item.date) + " 취소";
    case MemberMileageLogType.BUY_CANCEL:
      return item.menu;
    case MemberMileageLogType.MANUAL_CHARGE:
      return formatDateToMMDDSlash(new Date(item.expiredAt)) + " 소멸 예정";
    case MemberMileageLogType.MANUAL_CHARGE_CANCEL:
      return formatDateHHMM(item.date) + " 취소";
  }
};

export const checkMileageLogString = (type: MemberMileageLogType) => {
  switch (type) {
    case MemberMileageLogType.CASH:
      return "지급";
    case MemberMileageLogType.BANK:
      return "지급";
    case MemberMileageLogType.CARD:
      return "지급";
    case MemberMileageLogType.BUY:
      return "사용";
    case MemberMileageLogType.CASH_CANCEL:
      return "지급 취소";
    case MemberMileageLogType.BANK_CANCEL:
      return "지급 취소";
    case MemberMileageLogType.CARD_CANCEL:
      return "지급 취소";
    case MemberMileageLogType.BUY_CANCEL:
      return "사용 취소";
    case MemberMileageLogType.MANUAL_CHARGE:
      return "지급";
    case MemberMileageLogType.MANUAL_CHARGE_CANCEL:
      return "지급 취소";
    case MemberMileageLogType.EXPIRES:
      return "소멸";
  }
};

export const checkMileageLogType = (type: MemberMileageLogType) => {
  switch (type) {
    case MemberMileageLogType.CASH:
      return true;
    case MemberMileageLogType.BANK:
      return true;
    case MemberMileageLogType.CARD:
      return true;
    case MemberMileageLogType.BUY:
      return false;
    case MemberMileageLogType.CASH_CANCEL:
      return false;
    case MemberMileageLogType.BANK_CANCEL:
      return false;
    case MemberMileageLogType.CARD_CANCEL:
      return false;
    case MemberMileageLogType.BUY_CANCEL:
      return true;
    case MemberMileageLogType.MANUAL_CHARGE:
      return true;
    case MemberMileageLogType.MANUAL_CHARGE_CANCEL:
      return false;
    case MemberMileageLogType.EXPIRES:
      return false;
  }
};

//부상
export const checkSubPrizeLogType = (type: SubPrizeRewardLogType) => {
  switch (type) {
    case SubPrizeRewardLogType.REWARD:
      return true;
    case SubPrizeRewardLogType.REWARD_CANCEL:
      return false;
  }
};

// 시드
export const checkSeedLogType = (type: SeedLogType) => {
  switch (type) {
    case SeedLogType.USER_USE:
      return false;
    case SeedLogType.PUB_USE:
      return true;
    case SeedLogType.USER_USE_CANCEL:
      return true;
    case SeedLogType.PUB_USE_CANCEL:
      return false;
    case SeedLogType.PUB_TO_USER:
      return true;
    case SeedLogType.BOUNTY:
      return true;
    case SeedLogType.WITHDRAW:
      return false;
    case SeedLogType.WITHDRAW_CANCEL:
      return true;
    case SeedLogType.USER_CREATE:
      return true;
    case SeedLogType.USER_CREATE_CANCEL:
      return false;
    case SeedLogType.RESERVATION:
      return false;
    case SeedLogType.RESERVATION_CANCEL:
      return true;
    case SeedLogType.COMPANY_ADDITIONAL:
      return true;
    case SeedLogType.COMPANY_ADDITIONAL_CANCEL:
      return false;
    case SeedLogType.ADMIN_TOURNAMENT_REWARD:
      return true;
    case SeedLogType.RESERVATION_DISCOUNT:
      return true;
    case SeedLogType.RESERVATION_DISCOUNT_CANCEL:
      return false;
  }
};

// 포인트
export const checkPointLogType = (type: PointLogType, point: number) => {
  switch (type) {
    case PointLogType.TOURNAMENT_RESULT:
      return true;
    case PointLogType.TOURNAMENT_ENTRY:
      return false;
    case PointLogType.TOURNAMENT_REFUND:
      return true;
    case PointLogType.TOURNAMENT_REWARD:
      return true;
    case PointLogType.TOURNAMENT_REWARD_CANCEL:
      return false;
    case PointLogType.TOURNAMENT_RESULT_CANCEL:
      return false;
    case PointLogType.ADMIN_TOURNAMENT_RESULT:
      return true;
    case PointLogType.ADMIN_TOURNAMENT_RESULT_CANCEL:
      return false;
    case PointLogType.RESERVATION:
      return false;
    case PointLogType.RESERVATION_CANCEL:
      return true;
    case PointLogType.RESERVATION_DISCOUNT:
      return true;
    case PointLogType.RESERVATION_DISCOUNT_CANCEL:
      return false;
    case PointLogType.ADMIN_ADJUSTMENT:
      return point > 0 ? true : false;
    case PointLogType.DEPOSIT:
      return true;
    case PointLogType.DEPOSIT_CANCEL:
      return false;
    case PointLogType.PROMOTION:
      return true;
    case PointLogType.PROMOTION_CANCEL:
      return false;
  }
};
